import React, { useState } from 'react';
import { usePortalAuth } from './PortalAuthContext';

export function PortalLoginScreen() {
  const { login, error, clearError } = usePortalAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (submitting) return;
    if (!username.trim() || !password) return;
    setSubmitting(true);
    try {
      await login(username.trim(), password);
    } catch {
      // error already set by context
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="portal-screen portal-screen-centered">
      <div className="portal-card">
        <div className="portal-brand">
          <div className="portal-brand-primary">Katara PMS</div>
          <div className="portal-brand-secondary">Availability</div>
        </div>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className="portal-error">
              {error}
              <button
                type="button"
                onClick={clearError}
                className="portal-error-dismiss"
                aria-label="Dismiss"
              >×</button>
            </div>
          )}

          <label className="portal-label">
            <span className="portal-label-text">Email</span>
            <input
              type="email"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoComplete="username"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck={false}
              required
              className="portal-input"
              placeholder="your.email@example.com"
            />
          </label>

          <label className="portal-label">
            <span className="portal-label-text">Password</span>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="portal-input"
            />
          </label>

          <button
            type="submit"
            disabled={submitting || !username.trim() || !password}
            className="portal-button"
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div className="portal-footer">
          Need help? Contact your manager.
        </div>
      </div>
    </div>
  );
}
